// keep file in sync with CSS definitions

/**
 * `sm` breakpoint in pixels
 */
export const sm = 480;

/**
 * `md` breakpoint in pixels
 */
export const md = 768;

/**
 * `lg` breakpoint in pixels
 */
export const lg = 1024;

/**
 * `xl` breakpoint in pixels
 */
export const xl = 1536;
